import axios from "axios";

export default {
    get() {
        const API = `/api/payment/Currency`;

        return new Promise((resolve, reject) => {
            axios.post(API).then(res => {
                    resolve(res.data);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }
};